import angular from 'angular'
import currencies from 'json!../currency/currencies.json'

let module = angular.module('filtersModule', [])

.filter('trustHtml', ($sce) => {
  'ngInject'
  return (html) => {
    return $sce.trustAsHtml(html)
  }
})

.filter('escapeSingleQuote', () => {
  return (label) => {
    return label.replace(/'/g, '\\\'')
  }
})

.filter('price', ($filter, $locale, Localization) => {
  'ngInject'
  return (price) => {
    $locale.NUMBER_FORMATS = Object.assign({}, currencies[Localization.getLocalizedAppConfig().currency]['NUMBER_FORMATS'])
    if (!price) return price
    return (price.match(/free/i) || parseFloat(price.replace(/,/g, '.')) === 0)
      ? 'catalog.product.free'
      : $filter('currency')(parseFloat(price.replace(/,/g, '.')))
  }
})

.filter('orderTranslate', ($translate) => {
  'ngInject'
  return (key, prefix = '') => {
    return key.map(k => {
      return {
        k: k,
        v: $translate.instant(prefix + k.toLowerCase())
      } }).sort(function (a, b) {
        return (a.v > b.v) ? 1 : -1
      })
    .map(o => o.k)
  }
})

.name

export default module



// WEBPACK FOOTER //
// ./src/app/common/filters/index.js